import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/developer/')({
  loader: async () => {
    throw redirect({ to: '/developer/demo' });
  },
});
